import React from 'react'
import PropTypes from 'prop-types'

import NonMatchingList from './NonMatchingList'
import styles from './styles'

const MatchingRequirements = ({ nonMatchingRequirements }) => {
  if (!nonMatchingRequirements?.length) return null

  return (
    <>
      <h4 className={styles.headingWrapper}>You don't match</h4>
      <NonMatchingList nonMatchingRequirements={nonMatchingRequirements} />
    </>
  )
}

MatchingRequirements.propTypes = {
  nonMatchingRequirements: PropTypes.array,
}

export default MatchingRequirements
